import { applyHtmlSpecialChars } from "../util/";
import { CreateElement } from "./element";
import { OptionsParagraph } from "./paragraph";
import { CreateRpr, OptionsRpr } from "./rpr";

interface OptionsDateTime extends OptionsRpr {
    /** Date and time format. Default as "dd/MM/yyyy H:mm:ss" */
    format?: string;
}

/**
 * Create date and time
 */
class CreateDateTime extends CreateElement {
    /**
     * Element options
     */
    protected options: OptionsDateTime;

    /**
     * Constructor
     *
     * @param options - Options link
     * @param optionsParagraph - Options paragraph
     */
    constructor(
        options: OptionsDateTime,
        optionsParagraph: OptionsParagraph = {}
    ) {
        super();

        // default options
        options.format ??= "dd/MM/yyyy H:mm:ss";

        // apply paragraph rPr styles
        this.options = this.mergeParagraphRprStyles(options, optionsParagraph);
    }

    /**
     * Creates content
     *
     * @returns Contents
     */
    public create(): string {
        // rPr styles
        const rPrElement = new CreateRpr(this.options);
        const rPrStyles = rPrElement.create();

        let contents = "<w:r>";
        contents += rPrStyles;

        const optionFormat = this.options.format;
        if (optionFormat != null) {
            contents +=
                '<w:fldChar w:fldCharType="begin"/></w:r><w:r>' +
                rPrStyles +
                '<w:instrText xml:space="preserve">TIME \\@ &quot;' +
                applyHtmlSpecialChars(optionFormat) +
                "&quot; </w:instrText></w:r><w:r>" +
                rPrStyles +
                '<w:fldChar w:fldCharType="separate"/></w:r><w:r>' +
                rPrStyles;
        }

        contents +=
            '<w:t xml:space="preserve">date</w:t></w:r><w:r><w:fldChar w:fldCharType="end"/></w:r>';

        return contents;
    }
}

export { CreateDateTime, OptionsDateTime };
